import React, { useState } from 'react';
import DeviceDependentSettingUploadForm from './DeviceDependentSettingUploadForm'
import { Paper, Grid, withStyles } from '@material-ui/core';
import History from "../../../History";
import * as actions from './store/deviceDependentSettingActions';
import { snackActions } from '../../sc-utilities/SnackBar';
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const DeviceDependentSettingUpload = props => {
    const { classes, activeCustomerID, translations, permissions, onDeviceDependentSettingsUpload } = props;
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '', open: false });

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setFileToSend({ fileToSend: {}, fileName: '' });
            return;
        }
        setFileToSend({ ...fileToSend, fileToSend: file, fileName: file.name });
    };

    const handleSubmit = async event => {
        if (!fileToSend.fileName || (!fileToSend.fileName.includes('.json') && !fileToSend.fileName.includes('.xlsx'))) {
            return snackActions.snackBarComponent(translations['chose_xlsx_or_json'] || 'Please choose xlsx or json file', 'warning');
        }
        const data = new FormData();
        data.append("File", fileToSend.fileToSend);
        data.append("ActiveCustomerID", activeCustomerID);
        let token = localStorage.getItem("SESSION");

        data.append("Token", token);
        let result = await onDeviceDependentSettingsUpload(data);
        if (result) {
            History.goBack();
        }
    }

    let formSettings = {
        Validation: {
        },
        FormTitle: translations["import_device_dependent"] || "Import device dependent settings",
        ButtonSubmit: hasPermission(permissions, "device_dependent_setting_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <DeviceDependentSettingUploadForm
                        formSettings={formSettings}
                        handleSubmit={handleSubmit}
                        loading={!fileToSend.fileName}
                        handleUpload={handleUpload}
                        translations={translations}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onDeviceDependentSettingsUpload: dependentSetting => dispatch(actions.DeviceDependentSettingsUpload(dependentSetting))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DeviceDependentSettingUpload));